//get all employees

import { apiClient } from './axios';
import { RoleResponse } from './role';
export interface EmployeeFormData {
  name: string;
  email: string;
  phoneNumber: string;
  password?: string;
  roleId: number;
  dateOfBirth: string;
  address: string;
}

export interface IEmployee {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  dateOfBirth: string;
  address: string;
  role: RoleResponse;
  createdAt: string;
  updatedAt: string;
  password: string;
  status: userStatus;
  customerCount: number;
}

export interface EmployeeResponse {
  items: IEmployee[];
  totalItems: number;
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
}

export enum userStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const getEmployees = async (
  page: number,
  limit: number,
  search: string,
  status?: userStatus,
  roleKey?: string
): Promise<EmployeeResponse> => {
  const response = await apiClient.get<EmployeeResponse>('users', {
    params: {
      page,
      limit,
      search,
      orderBy: 'createdAt:DESC',
      status,
      role: roleKey,
    },
  });
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const createEmployee = async (data: EmployeeFormData) => {
  const response = await apiClient.post('users', data);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export const updateEmployee = async (id: string, data: EmployeeFormData) => {
  const response = await apiClient.patch(`users/${id}`, data);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

//delete employee
export const deleteEmployee = async (id: string) => {
  const response = await apiClient.delete(`users/${id}`);
  if (!response.success && response?.error) {
    throw new Error(response.message);
  }
  return response.data;
};

export const getEmployeeRoleIsSeller = async (): Promise<IEmployee[]> => {
  const response = await apiClient.get<IEmployee[]>(`users/marketing`);
  return response.data;
};

export const changeStatusEmployee = async (
  id: string,
  status: userStatus,
  idEmployeeNew?: number
) => {
  const response = await apiClient.patch(`users/${id}/status`, {
    status: status,
    idEmployeeNew: idEmployeeNew,
  });
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};

export interface ChangePasswordFormData {
  currentPassword: string;
  newPassword: string;
}

export const changePassword = async (data: ChangePasswordFormData) => {
  const response = await apiClient.patch('users/change-password', data);
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};
